/**
 * @file Purchase Album Photos reducer.
 */

import {
  SELECT_PHOTO,
  DESELECT_PHOTO,
  CHECKOUT_REQUEST,
  CHECKOUT_SUCCESS,
  CHECKOUT_FAILURE,
} from '../actions/purchase-album-photos';

const initialState = {
  photos: [],
  loading: false,
  error: '',
  success: false,
  purchasedUrl: null,
};

const purchaseAlbumPhotosReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SELECT_PHOTO:
      return {
        ...state,
        photos: [...state.photos, action.photo],
      };

    case DESELECT_PHOTO:
      return {
        ...state,
        photos: state.photos.filter(photo => photo.id !== action.photo.id),
      };

    case CHECKOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        success: false,
        purchasedUrl: null,
      };

    case CHECKOUT_SUCCESS:
      return {
        ...state,
        photos: [],
        loading: false,
        error: '',
        success: true,
        purchasedUrl: action.purchasedUrl,
      };

    case CHECKOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message || action.error,
        success: false,
      };

    default:
      return state;
  }
};

export { initialState };
export default purchaseAlbumPhotosReducer;
